export const coreErrorCodes = [
  'initialization_failed',
  'invalid_environment',
  'invalid_domain_state',
  'invalid_graph',
  'ingestion_failed',
  'unsupported_source',
  'source_too_large',
  'source_corrupted',
  'ingestion_cancelled',
  'storage_unavailable',
  'runtime_unavailable',
  'offline',
  'permission_denied',
  'unexpected',
] as const;

export type CoreErrorCode = (typeof coreErrorCodes)[number];

export interface CoreErrorState {
  readonly code: CoreErrorCode;
  readonly message: string;
  readonly retryable: boolean;
  readonly details: Readonly<Record<string, string>>;
}

export class NoemirError extends Error {
  readonly state: CoreErrorState;

  constructor(state: CoreErrorState, options?: ErrorOptions) {
    super(state.message, options);
    this.name = 'NoemirError';
    this.state = state;
  }
}

export const toNoemirError = (error: unknown): NoemirError => {
  if (error instanceof NoemirError) {
    return error;
  }

  if (error instanceof Error) {
    return new NoemirError(
      {
        code: 'unexpected',
        message: 'The application encountered an unexpected error.',
        retryable: false,
        details: { cause: error.name },
      },
      { cause: error },
    );
  }

  return new NoemirError({
    code: 'unexpected',
    message: 'The application encountered an unknown error.',
    retryable: false,
    details: {},
  });
};
